import React from 'react'
import ButtonGroup from '../../../components/ButtonGroup'

const ButtonGroupWidget = ({ container: Container, items }) => (
  <Container my={[35]}>
    <ButtonGroup items={items} />
  </Container>
)

export default ButtonGroupWidget
